//#region src/schema/helpers/get-discriminator-values.ts
var e = (e, t) => !e || !t ? [] : Object.entries(t).filter(([, t]) => t === e || `#/components/schemas/${t}` === e).map(([e]) => e);
//#endregion
export { e as getDiscriminatorValues };

//# sourceMappingURL=get-discriminator-values.js.map